import LoadingStatus from '@libs/loading-status';

import {
  DOCUMENTS__DOCUMENT_REUSE_FAILURE,
  DOCUMENTS__DOCUMENT_REUSE_REQUEST,
  DOCUMENTS__DOCUMENT_REUSE_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentsAction } from '@app/store/documents/actions';

type DocumentUploadStatusState = LoadingStatus;

const initialState: DocumentUploadStatusState = LoadingStatus.IDLE;

export default function reducer(
  state: DocumentUploadStatusState = initialState,
  action: DocumentsAction
) {
  switch (action.type) {
    case DOCUMENTS__DOCUMENT_REUSE_REQUEST:
      return LoadingStatus.PENDING;
    case DOCUMENTS__DOCUMENT_REUSE_SUCCESS:
      return LoadingStatus.SUCCEEDED;
    case DOCUMENTS__DOCUMENT_REUSE_FAILURE:
      return LoadingStatus.FAILED;
    default:
      return state;
  }
}
